<template>
    <div class="l-data-panel l-rblock">
        <div class="l-data-panel--title" >
            {{label}}
            <button v-if="isMore" @click="handleClick" type="button" class="el-button el-button--text"><span>更多</span></button>
        </div>
        <div class="l-rblock" >
            <slot></slot>
        </div>
    </div> 
</template>
<script>
export default {
    name:'l-data-panel',
    props: {
        label:String,
        isMore:Boolean
    },
    data(){
        return {
        }
    },
    computed:{
    },
    methods:{
        handleClick(){
            this.$emit('more')
        }
    }
}
</script>

<style lang="less">
@import './index.less';
</style>
